const VERSION = "10.0.7";
export {
  VERSION
};
